import { useState, useContext } from 'react';

import GenericToast from '@/components/atoms/generic-toast/genericToast';
import ToBeAwareImage from '@/components/atoms/to-be-aware-image/toBeAwareImage';
import UseTraceItemShipping from '@/hooks/UseTraceItemShipping';

import GlobalContext from '../../../contexts/globalContext';
import UseVerificationDigit from '../../../hooks/UseVerificationDigit';
import { getIncomeCertificate } from '../../../services/certificate-services';
import Loader from '../../atoms/loader/loader';
import LoginRequest from '../../organisms/login-request/login-request';
import BusinessModal from '../bussiness-modal/businessModal';
import PdfViewModal from '../pdf-view-modal/pdfViewModal';
import './incomeCertificate.scss';

const IncomeCertificate = ({ contentInfo, note, imagen }: any) => {
  const [loader, setLoader] = useState(false);
  const [certificate, setCertificate] = useState<any>('');
  const [visualizationModal, setVisualizationModal] = useState<any>(false);
  const { gigyaContext, selectedTab, business, userInfoContext } = useContext(GlobalContext);
  const [openToast, setOpenToast] = useState<any>(false);
  const [openBusinessModal, setOpenBusinessModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [needSession, setNeedSession] = useState(false);

  const alertError = (userMessage: string) => {
    return setOpenToast(
      <GenericToast
        message={userMessage}
        position="up-right-small"
        setActiveToast={setOpenToast}
        size="small"
      />,
    );
  };

  const getCertifcate = async () => {
    setLoader(true);
    if (selectedTab?.get === 'empresas') {
      if (business?.get) {
        UseTraceItemShipping(
          `${gigyaContext?.gigyaAccount?.profile.firstName} ${
            gigyaContext?.gigyaAccount?.data.secondName
              ? `${gigyaContext.gigyaAccount.data.secondName} `
              : ''
          }${gigyaContext?.gigyaAccount?.profile.lastName}${
            gigyaContext?.gigyaAccount?.data.secondLastName
              ? ` ${gigyaContext?.gigyaAccount?.data.secondLastName}`
              : ''
          }`,
          gigyaContext?.gigyaAccount?.data.docNumber,
          gigyaContext?.gigyaAccount?.data.docType,
          gigyaContext?.gigyaAccount?.profile.email,
          'click',
          'CertificadosYConsultas :: EstadoCuentaAporte :: } GenerarCertificado',
          userInfoContext.data?.userJwt,
        );
        const enterpriseDocument =
          business?.get?.companyDocID +
          (business.get.companyDocType === 'CO1N'
            ? UseVerificationDigit(String(business?.get?.companyDocID))
            : '');
        getIncomeCertificate(enterpriseDocument)
          .then((res) => {
            if (res?.data?.data?.certificadoB64) {
              setCertificate(res.data.data.certificadoB64);

              setVisualizationModal(
                <PdfViewModal
                  base64={certificate || res.data.data.certificadoB64}
                  setActiveModal={setVisualizationModal}
                  selectedFileName="Certificado de deuda"
                  setActiveToast={() => false}
                />,
              );
            } else {
              alertError('Actualmente este Nit no tiene información disponible');
            }
          })
          .catch((error) => {
            console.log(error);
            alertError('Este número de identificación no tiene información disponible');
          })
          .finally(() => {
            setLoader(false);
          });
      } else {
        setOpenBusinessModal(true);
      }
    } else if (gigyaContext.gigyaAccount) {
      UseTraceItemShipping(
        `${gigyaContext?.gigyaAccount?.profile.firstName} ${
          gigyaContext?.gigyaAccount?.data.secondName
            ? `${gigyaContext.gigyaAccount.data.secondName} `
            : ''
        }${gigyaContext?.gigyaAccount?.profile.lastName}${
          gigyaContext?.gigyaAccount?.data.secondLastName
            ? ` ${gigyaContext?.gigyaAccount?.data.secondLastName}`
            : ''
        }`,
        gigyaContext?.gigyaAccount?.data.docNumber,
        gigyaContext?.gigyaAccount?.data.docType,
        gigyaContext?.gigyaAccount?.profile.email,
        'click',
        'CertificadosYConsultas :: EstadoCuentaAporte :: } GenerarCertificado',
        userInfoContext.data?.userJwt,
      );
      getIncomeCertificate(gigyaContext.gigyaAccount.data.docNumber)
        .then((res) => {
          if (res.data.data.certificadoB64) {
            setCertificate(res.data.data.certificadoB64);

            setVisualizationModal(
              <PdfViewModal
                base64={certificate || res.data.data.certificadoB64}
                setActiveModal={setVisualizationModal}
                selectedFileName="Certificado de deuda"
                setActiveToast={() => false}
              />,
            );
          } else {
            alertError('Este número de identificación no tiene información disponible');
          }
        })
        .catch((error) => {
          console.log(error);
          alertError('Este número de identificación no tiene información disponible');
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      setNeedSession(true);
    }
  };

  return (
    <>
      {needSession ? (
        <LoginRequest />
      ) : (
        <section className="m-income-certificate">
          <div className="m-income-certificate__body">
            <ToBeAwareImage image={imagen[0]} content={note} />
            <div className="m-income-certificate__body__form">
              {contentInfo && contentInfo[0] && (
                <div className="m-income-certificate__body__form__info">
                  <h3 className="m-income-certificate__body__form__info__title">
                    {contentInfo[0].nombre}
                  </h3>
                  <span className="m-income-certificate__body__form__info__subtitle">
                    {contentInfo[0].subtitulo}
                  </span>
                </div>
              )}
              <button
                className="m-income-certificate__form__button"
                disabled={loader}
                onClick={() => {
                  getCertifcate();
                }}
              >
                {loader ? (
                  <Loader size="__small" />
                ) : (
                  contentInfo?.[0]?.boton?.[0]?.copy || 'Generar certificado'
                )}
              </button>
            </div>
            {visualizationModal && <>{visualizationModal}</>}
            {openToast && <>{openToast}</>}
            {openBusinessModal && (
              <BusinessModal
                closeModal={() => setOpenBusinessModal(false)}
                isMobile
                setShowConfirmation={setShowConfirmation}
                isPrivate={false}
                closeModalPermissionPage={() => setOpenBusinessModal(false)}
                serviceId={contentInfo.serviceId}
              />
            )}
            {showConfirmation && <>{showConfirmation}</>}
          </div>
        </section>
      )}
    </>
  );
};

export default IncomeCertificate;
